export default __webpack_public_path__ + "static/media/bakery-red.85cc4ea4.gif";